<div class="content-container">
    <div class="content">
        <div class="newsletter">
            <a class="reset-styles" routerLink="/home">
                <div class="logo"></div>
            </a>
            <p>Join our community and stay updated with the latest news, projects, and insights. Follow us on social media.</p>
            <h4>Sign up to the newsletter</h4>

            <mat-form-field class="dark">
                <input matInput [placeholder]="'Your email'"
                    [formControl]="newsletterEmail">
                @if (newsletterEmail.hasError('email') && !newsletterEmail.hasError('required')) {
                <mat-error>Please enter a valid email address</mat-error>
                }
                @if (subscriptionMessage) {
                <mat-hint class="subscription-message">{{ subscriptionMessage }}</mat-hint>
                }
            </mat-form-field>
            <app-button [style]="'flat'" [color]="'accent'" [arrow]="true" [disabled]="!newsletterEmail.valid"
                (click)="onSubscribe()">
                Subscribe
            </app-button>
        </div>
        <div class="navigation">
            <div>
                <h4>Navigation</h4>
                <p class="link" *ngFor="let item of navItems">
                    <a class="reset-styles" [routerLink]="item.nav">
                        {{item.title}}
                    </a>
                </p>
            </div>
            <div>
                <h4>Services & Solutions</h4>
                <p class="link" *ngFor="let item of serviceItems.children">
                    <a class="reset-styles" [routerLink]="item.nav">
                        {{item.title}}
                    </a>
                </p>
            </div>
        </div>
    </div>
    <div class="bottom">
        <div>
            <a href="https://www.linkedin.com/company/relief-applications" target="_blank" class="linkedin logo"></a>
            <a href="https://www.youtube.com/@reliefapplications5947" target="_blank" class="youtube logo"></a>
        </div>
        <p>{{'All rights reserved' + ' © ' + currentYear}}</p>
        <div>
            <p routerLink="privacy-policy" class="link">Privacy Policy</p>
            <p routerLink="terms-of-services" class="link">Terms of Services</p>
        </div>
    </div>
</div>